import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {EstimateContext} from '../context/EstimateContext';

export default function CustomerInformationPanel() {

	const { order } = useContext(EstimateContext);

	return (
		<>
			<Panel
				header={'Customer Information'}
			>
				<Field label={'Name'} >{order.details.customerName}</Field>
				<Field label={'Address'} >{order.details.customerAddress1}</Field>
				<Field label={''} visible={!!order.details.customerAddress2}>{order.details.customerAddress2}</Field>
				<Field label={''} >{order.details.customerCityZip}</Field>
				<Field label={'Phone'} >{order.details.customerPhone}</Field>
				<Field label={'Alternate Phone'} >{order.details.customerAlternatePhone}</Field>
				<Field label={'Email'} > <a href={'mailto:' + order.details.customerEmail}>{order.details.customerEmail}</a></Field>
			</Panel>
		</>
	);
}
